module.exports = __webpack_public_path__ + "static/media/itron.167c9287.pdf";